import { Grid } from "@mui/material";
import { FreeMode, Pagination } from "swiper/modules";

import { DesktopVersion } from "../styles/ProductsStyles";
import type { ProductProps } from "./ProductsTypes";
import ProductPlanCard from "./ProductPlanCard";
import ProductsSwiper from "./ProductsSwiper";
import {
  getDesktopGridSize,
  getProductKey,
  MAX_VISIBLE_CARDS_WITHOUT_SWIPER,
} from "./productsCardUtils";
import { useProductDetailsClick } from "./useProductDetailsClick";
import { useSwiperPagination } from "./useSwiperPagination";

export function ProductsDesktop({
  products,
  navigate,
  navigateOut,
}: Readonly<ProductProps>) {
  const pagination = useSwiperPagination();
  const handleProductDetailsClick = useProductDetailsClick(navigate);

  const shouldRenderSwiper =
    products.length > MAX_VISIBLE_CARDS_WITHOUT_SWIPER;

  return (
    <DesktopVersion container>
      {!shouldRenderSwiper &&
        products.map((product) => (
          <Grid
            size={getDesktopGridSize(products.length)}
            sx={{ minWidth: "300px" }}
            key={getProductKey(product)}
          >
            <ProductPlanCard
              product={product}
              gtmHandleClick={handleProductDetailsClick}
              navigateOut={navigateOut}
              offerStampMode="price"
              priceLabelMode="always"
              showOldPriceCurrency={false}
            />
          </Grid>
        ))}

      {shouldRenderSwiper && (
        <ProductsSwiper
          products={products}
          navigateOut={navigateOut}
          gtmHandleClick={handleProductDetailsClick}
          freeMode
          grabCursor
          keyboard
          slidesPerView={4.2}
          spaceBetween={4}
          pagination={pagination}
          modules={[FreeMode, Pagination]}
          withMargin
        />
      )}
    </DesktopVersion>
  );
}

export default ProductsDesktop;